import axios from "axios";
import { IURLParams, ISignInData } from "../interfaces/index";
import { MIDDLEWARE_URL } from "../config/environment";

// used to get initial data from middleware, and will be called ONLY on startup
export const signInOnAleaOnline = async (
  params: IURLParams
): Promise<ISignInData> => {
  try {
    const response = await axios.get(MIDDLEWARE_URL, {
      params,
      withCredentials: true,
    });
    return response.data;
  } catch (e) {
    return Promise.reject(e);
  }
};
